import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BsModalService } from 'ngx-bootstrap/modal';
import { of } from 'rxjs/internal/observable/of';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AdminSatelliteService } from '../../services/admin/admin-satellite.service';
import { ConnectionProfilesComponent } from '../connection-profiles.component';
import { ConnectionProfilesActions } from './connection-profiles.actions';

@Injectable()
export class ConnectionProfilesEffects {
    constructor(
        private actions$: Actions,
        private modalService: BsModalService,
        private adminSatelliteService: AdminSatelliteService) {
    }

    openConnectionProfileDialog$ = createEffect(() =>
            this.actions$
                .pipe(
                    ofType(ConnectionProfilesActions.openConnectionProfileDialog),
                    map(({autoremindAccount, selectedConnectionProfile}) => {
                        this.modalService
                            .show(ConnectionProfilesComponent,
                                {
                                    initialState: {
                                        autoremindAccount,
                                        selectedConnectionProfile
                                    },
                                    backdrop: 'static',
                                    class: 'modal-lg-preview'

                                });
                    })),
        {dispatch: false}
    );

    connectionProfiles$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ConnectionProfilesActions.getConnectionProfiles),
            switchMap((action: any) =>
                this.adminSatelliteService
                    .getConnectionProfiles()
                    .pipe(
                        map((response: any) =>
                            ConnectionProfilesActions
                                .getConnectionProfilesSuccess({connectionProfiles: response.connectionProfiles})
                        ),
                        catchError(error =>
                            of(ConnectionProfilesActions.getConnectionProfilesFail({error: error.error.error.reason}))
                        )
                    )
            )
        )
    );

    updateConnectionProfiles$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ConnectionProfilesActions.updateConnectionProfiles),
            switchMap((action: any) =>
                this.adminSatelliteService
                    .updateConnectionProfiles(action.autoremindAccount, action.selectedConnectionProfileId)
                    .pipe(
                        map((response: any) =>
                            ConnectionProfilesActions
                                .updateConnectionProfilesSuccess()
                        ),
                        catchError(error =>
                            of(ConnectionProfilesActions.updateConnectionProfilesFail({error: error.error.error.reason}))
                        )
                    )
            )
        )
    );
}
